import { render, staticRenderFns } from "./learning.vue?vue&type=template&id=a1b34c0c&scoped=true"
import script from "./learning.vue?vue&type=script&lang=js"
export * from "./learning.vue?vue&type=script&lang=js"
import style0 from "./learning.vue?vue&type=style&index=0&id=a1b34c0c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1b34c0c",
  null
  
)

export default component.exports